// Search action types
export const SEARCH_ARTICLES_REQUEST = 'SEARCH_ARTICLES_REQUEST';
export const SEARCH_ARTICLES_SUCCESS = 'SEARCH_ARTICLES_SUCCESS';
export const SEARCH_ARTICLES_FAILURE = 'SEARCH_ARTICLES_FAILURE';

export const SEARCH_CATEGORIES_REQUEST = 'SEARCH_CATEGORIES_REQUEST';
export const SEARCH_CATEGORIES_SUCCESS = 'SEARCH_CATEGORIES_SUCCESS';
export const SEARCH_CATEGORIES_FAILURE = 'SEARCH_CATEGORIES_FAILURE';

export const SEARCH_AUTHORS_REQUEST = 'SEARCH_AUTHORS_REQUEST';
export const SEARCH_AUTHORS_SUCCESS = 'SEARCH_AUTHORS_SUCCESS';
export const SEARCH_AUTHORS_FAILURE = 'SEARCH_AUTHORS_FAILURE';

export const GLOBAL_SEARCH_REQUEST = 'GLOBAL_SEARCH_REQUEST';
export const GLOBAL_SEARCH_SUCCESS = 'GLOBAL_SEARCH_SUCCESS';
export const GLOBAL_SEARCH_FAILURE = 'GLOBAL_SEARCH_FAILURE';

export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';


